
export interface OrderProfile {
  full_name: string | null;
  email: string | null;
}

export function isValidProfile(profile: any): profile is OrderProfile {
  return (
    profile &&
    typeof profile === 'object' &&
    profile !== null &&
    typeof profile.full_name === 'string' &&
    typeof profile.email === 'string'
  );
}

export function safeGetProfileName(profile: any): string {
  return isValidProfile(profile) ? profile.full_name || 'Unknown User' : 'Unknown User';
}

export function safeGetProfileEmail(profile: any): string {
  return isValidProfile(profile) ? profile.email || 'No email' : 'No email';
}

export interface SafeOrderProfile {
  full_name: string;
  email: string;
}

export function getSafeProfile(profile: any): SafeOrderProfile {
  if (isValidProfile(profile)) {
    return {
      full_name: profile.full_name || 'Unknown User',
      email: profile.email || 'No email'
    };
  }
  return {
    full_name: 'Unknown User',
    email: 'No email'
  };
}
